<div class="modal-header add_employee_popup">

    <h3>Add Employee</h3>

    <button type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
    </button>


</div>

<div>
    <div class="modal-content" style="border: none;">
        <!-- <div class="modal-header">
             <button type="button" class="close" aria-label="Close" (click)="activeModal.close()"style="padding: 5px 10px;float:right;">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>   -->


        <div class="modal-body mod-emp">
            <div class="container">
                <div class="col-md-12">
                    <form #employeeForm="ngForm" [mustMatch]="['password', 'confirmPassword']" novalidate>

                        <div class="row">
                            <div class="col-sm-4 add-employee_sum_col">
                                <div class="form-group has-feedback ">
                                    <label for="firstName" class="control-label txt_label">First Name</label>

                                    <div class="add-employee-input-group">
                                        <input type="text" class="form-control" id="firstName" name="firstName"
                                            #firstName="ngModel"
                                            [ngClass]="{ 'is-invalid': firstName.invalid && (firstName.dirty || firstName.touched) }"
                                            [(ngModel)]="viewModel.FirstName" placeholder="First Name" required
                                            minlength="2">
                                        <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)"
                                            class="invalid-feedback">
                                            <div *ngIf="firstName.errors?.required">First Name is required</div>
                                            <div *ngIf="firstName.errors?.minlength">Minimum 2 chracter is required</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 add-employee_sum_col">
                                <div class="form-group has-feedback ">
                                    <label for="lastName" class="control-label txt_label">Last Name</label>

                                    <div class="add-employee-input-group">
                                        <input type="text" class="form-control" id="lastName" name="lastName"
                                            #lastName="ngModel"
                                            [ngClass]="{ 'is-invalid': lastName.invalid && (lastName.dirty || lastName.touched) }"
                                            [(ngModel)]="viewModel.LastName" placeholder="Last Name" required
                                            minlength="2">
                                        <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)"
                                            class="invalid-feedback">
                                            <div *ngIf="lastName.errors?.required">Last Name is required</div>
                                            <div *ngIf="lastName.errors?.minlength">Minimum 2 chracter is required</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 add-employee_sum_col">
                                <div class="form-group has-feedback ">
                                    <label for="email" class="control-label txt_label">Email</label>
                                    <div class="add-employee-input-group">
                                        <input type="email" class="form-control" id="email" name="email"
                                            #email="ngModel"
                                            [ngClass]="{ 'is-invalid': email.invalid && (email.dirty || email.Select) }"
                                            pattern="[a-zA-Z0-9]\.?([a-zA-Z0-9._%+-])+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                            [(ngModel)]="viewModel.Email" placeholder="Email" required>
                                        <div *ngIf="(email.dirty || email.touched) && email.invalid "
                                            class="invalid-feedback">
                                            <div *ngIf="email.errors?.required">Email is required</div>
                                            <div *ngIf="email.errors?.pattern">Invalid Email</div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-sm-4 add-employee_sum_col">
                                <div class="form-group">
                                    <label class="control-label txt_label">User Type</label>
                                    <select class="form-control" name="userType" [(ngModel)]="viewModel.UserType"
                                        #userType="ngModel" required>

                                        <option value="">--- Select user type---</option>
                                        <option>Admin</option>
                                        <option>Driver</option>
                                        <option>Employee</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-sm-4 add-employee_sum_col">
                                <div class="form-group has-feedback ">
                                    <label for="userName" class="control-label txt_label">User Name</label>

                                    <div class="add-employee-input-group">
                                        <input type="text" class="form-control" id="userName" name="userName"
                                            #userName="ngModel"
                                            [ngClass]="{ 'is-invalid': userName.invalid && (userName.dirty || userName.touched) }"
                                            [(ngModel)]="viewModel.UserName" placeholder="User Name" required
                                            minlength="2">
                                        <div *ngIf="userName.invalid && (userName.dirty || userName.touched)"
                                            class="invalid-feedback">
                                            <div *ngIf="userName.errors?.required">UserName is required</div>
                                            <div *ngIf="userName.errors?.minlength">Minimum 2 chracter is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 add-employee_sum_col">
                                <div class="form-group has-feedback ">
                                    <label for="password" class="control-label txt_label">Password</label>

                                    <div class="add-employee-input-group">
                                        <input type="password" class="form-control" id="password" name="password"
                                            pattern="(?=^.{2,50}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[A-Z]).*$"
                                            #password="ngModel"
                                            [ngClass]="{ 'is-invalid': password.invalid && (password.dirty || password.touched) }"
                                            [(ngModel)]="viewModel.Password" placeholder="Password" required
                                            minlength="2">
                                        <div *ngIf="password.invalid && (password.dirty || password.touched)"
                                            class="invalid-feedback">
                                            <div *ngIf="password.errors?.required">Required</div> 
                                            <div *ngIf="password.errors?.pattern">Password require at least one capital
                                                letter and one number</div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 add-employee_sum_col">
                                <div class="form-group has-feedback ">
                                    <label for="confirmPassword" class="control-label txt_label">Confirm
                                        Password</label>

                                    <div class="add-employee-input-group">
                                        <input type="password" class="form-control" id="confirmPassword"
                                            name="confirmPassword" #confirmPassword="ngModel"
                                            [ngClass]="{ 'is-invalid': confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched) }"
                                            [(ngModel)]="viewModel.ConfirmPassword" placeholder="Confirm Password"
                                            required>
                                        <div *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched) "
                                            class="invalid-feedback">
                                            <div *ngIf="confirmPassword.errors?.required">Required</div>
                                            <div *ngIf="confirmPassword.errors?.mustMatch">Passwords must match</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="row btn_r8">

                            <div class="add-employee_sum_col">
                                <div class="form-group add-employee_sum_top add-employee_sum_top">
                                    <div class="pull-right rightpul">
                                        <button type="submit" class="btn btn-primary btn-save-blu button_ri8"
                                            [disabled]="viewModel.Password != viewModel.ConfirmPassword || employeeForm.invalid"
                                            (click)="employeeUpdate()">Save</button>
                                        <button type="reset" class="btn btn-default" >Cancel</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>